/**
 * Minimal browser shim for Node's `assert` module.
 * Uses .cjs so Vite treats it as CommonJS — this ensures both:
 *   - CJS deps: require('assert') returns the function directly
 *   - ESM deps: import assert from 'assert' gets the function via CJS interop
 */

class AssertionError extends Error {
  constructor(message) {
    super(message || "assert failed");
    this.name = "AssertionError";
  }
}

function assert(value, message) {
  if (!value) {
    throw new AssertionError(message || "Expected truthy value, got " + String(value));
  }
}

assert.ok = assert;

assert.equal = function (actual, expected, message) {
  if (actual != expected) {
    throw new AssertionError(message || "Expected " + actual + " == " + expected);
  }
};

assert.strictEqual = function (actual, expected, message) {
  if (actual !== expected) {
    throw new AssertionError(message || "Expected " + actual + " === " + expected);
  }
};

assert.notEqual = function (actual, expected, message) {
  if (actual == expected) {
    throw new AssertionError(message || "Expected " + actual + " != " + expected);
  }
};

assert.notStrictEqual = function (actual, expected, message) {
  if (actual === expected) {
    throw new AssertionError(message || "Expected " + actual + " !== " + expected);
  }
};

assert.deepEqual = function (actual, expected, message) {
  if (JSON.stringify(actual) !== JSON.stringify(expected)) {
    throw new AssertionError(message || "deepEqual failed");
  }
};

assert.deepStrictEqual = assert.deepEqual;

assert.fail = function (message) {
  throw new AssertionError(message || "assert.fail");
};

assert.AssertionError = AssertionError;

module.exports = assert;
